import React from 'react'
import { connect } from 'react-redux'
import DynamicTable from '../../component/DynamicTable'
import instancepartAction from '../../action/instancepart'
import { localization, secondaryTableOptions, formatTotalElements, getQueryParams } from '../../helper/table'
import { useParams } from 'react-router-dom'


function InstancepartsTable({ dispatch, totalCount }) {
  const params = useParams()

  const fetchPaginatedData = query => dispatch(instancepartAction.readPaginated(getQueryParams({ ...query, appId: params.appId })))

  return (
    <DynamicTable
      columns={[
        { title: "Id", field: "id" },
        { title: "Uid", field: "instancepart_id" },
        { title: "Titolo", field: "title" },
        { title: "Thumbnail", field: "thumb_filename" },
        { title: "Geometria", field: "geometry_title" },
        { title: "Mappa AO", field: "aomap_title" },
        { title: "Patternmix default", field: "default_patternmix_title" },
        // { title: "App", field: "app_title" },
        { title: "Abilitato", field: "is_disabled", render: rowData => !rowData.is_disabled ? 'Si' : 'No' },
        { title: "Extra", field: "extra" },
      ]}
      data={fetchPaginatedData}
      title={formatTotalElements(totalCount)}
      options={secondaryTableOptions}
      localization={localization}
    />
  )
}

const mapStateToProps = store => {
  const { instancepart } = store
  return {
    totalCount: instancepart.totalCount
  }
}


export default connect(mapStateToProps)(InstancepartsTable)